/**
 * General utility functions
 */
import { Weekdays } from '../types/simpledate';
export function mod(n, m) {
    return ((n % m) + m) % m;
}
export function capitalize(str, doThis = true) {
    return doThis ? str[0].toUpperCase() + str.slice(1) : str;
}
export function isAnyTrueish(...values) {
    return values.some(v => !!v);
}
export function isAnyFalsish(...values) {
    return values.some(v => !v);
}
export function findBest(list, isABetterThanB) {
    if (!list.length)
        return undefined;
    if (list.length == 1)
        return list[0];
    return list.reduce((a, b) => isABetterThanB(a, b) ? a : b);
}
export function addErrorClassIf(condition, className, addedClass = 'error') {
    return condition ? `${className !== null && className !== void 0 ? className : ''} ${addedClass}` : className;
}
export function noWhitespaceTrim(value) {
    return value.replace(/\s+/g, '');
}
export const noWhitespaceTrimmer = (s) => s.replace(/\s+/g, '');
export function abbreviateText(text, maxLength = 64) {
    if (!text)
        return '';
    return text.length > maxLength ? text.trim().slice(0, maxLength - 3) + '...' : text;
}
export function findTextCutoffPoint(text) {
    if (text.length <= 120)
        return text.length;
    const sentenceEndings = /[.!?]\s/g;
    let match;
    let lastEndBefore200 = -1;
    let firstEndAfter120 = -1;
    while ((match = sentenceEndings.exec(text)) !== null) {
        const endPos = match.index + 1;
        if (endPos >= 120 && firstEndAfter120 == -1)
            firstEndAfter120 = endPos;
        if (endPos <= 200)
            lastEndBefore200 = endPos;
    }
    if (lastEndBefore200 >= 120)
        return lastEndBefore200;
    if (firstEndAfter120 > 0 && firstEndAfter120 <= 200)
        return firstEndAfter120;
    const cutAt = 120;
    const beforeCut = text.substring(0, Math.min(cutAt, 200));
    const lastSpace = beforeCut.lastIndexOf(' ');
    if (lastSpace > 0)
        return lastSpace;
    return Math.min(120, text.length);
}
let lastAttempts = [];
export function limitRepeatedCalls(key, callback, limitMs = 500) {
    const now = Date.now();
    console.log('limitRepeatedCalls', key, new Date(now));
    const entry = lastAttempts.find(it => it.key == key);
    if (!entry) {
        console.log('limitRepeatedCalls new');
        const r = callback(key);
        if (lastAttempts.length > 10)
            lastAttempts.shift();
        lastAttempts.push({ key, timestamp: now, result: r });
        return r;
    }
    else if (Math.abs(now - entry.timestamp) > limitMs) {
        console.log('limitRepeatedCalls time');
        entry.result = callback(key);
        entry.timestamp = now;
    }
    return entry.result;
}
export function relativeDateToText(duration, dayDiff, baseOnWeekday) {
    const weekDiff = Math.floor(dayDiff / 7);
    if (dayDiff > 1) {
        const durS = `in ${duration}`;
        return (baseOnWeekday != null && weekDiff < 2) ? `${weekDiff ? 'next' : 'this'} ${Weekdays[(baseOnWeekday + dayDiff) % 7]} (${durS})` : durS;
    }
    else if (dayDiff < -1) {
        const durS = `${duration} ago`;
        return (baseOnWeekday != null && weekDiff > -2) ? `last ${Weekdays[(baseOnWeekday + dayDiff + 7) % 7]} (${durS})` : durS;
    }
    else if (dayDiff == 1)
        return `tomorrow`;
    else if (dayDiff == -1)
        return `yesterday`;
    else
        return 'today';
}
